module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isExist),
      expression: "isExist"
    }],
    class: _vm.classes,
    style: (_vm.styles)
  }, [_c('div', {
    ref: "container",
    class: _vm.containerClasses,
    style: (_vm.containerStyles)
  }, [_c('div', {
    staticClass: "bc-banner-carousel__scroller"
  }, [_c('a', {
    staticClass: "bc-banner-carousel__btn bc-banner-carousel__btn-prev",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.prev($event)
      }
    }
  }, [_c('span', [_vm._v("前へ")])]), _vm._v(" "), (_vm.isExist) ? _c('ul', {
    class: _vm.sliderClasses,
    style: (_vm.sliderStyles)
  }, _vm._l((_vm.computedItems), function(item, index) {
    return _c('v-touch', {
      key: index,
      class: _vm.itemClasses,
      style: (item.style),
      attrs: {
        "tag": "li",
        "pan-options": {
          direction: 'horizontal',
          threshold: 0
        }
      },
      on: {
        "panstart": _vm.onPanStart,
        "panmove": _vm.onPanMove,
        "panend": _vm.onPanEnd,
        "pancancel": _vm.onPanEnd
      }
    }, [_c('a', {
      attrs: {
        "href": item[("url_" + _vm.mq)],
        "target": item.blankWindow,
        "tabindex": "-1",
        "draggable": "false"
      },
      on: {
        "click": function($event) {
          _vm.onItemClick(item, $event)
        },
        "dragstart": function($event) {
          $event.preventDefault();
        },
        "dragmove": function($event) {
          $event.preventDefault();
        },
        "dragend": function($event) {
          $event.preventDefault();
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item[("fileName_" + _vm.mq)],
        "alt": "",
        "draggable": "false"
      }
    })])])
  })) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "bc-banner-carousel__btn bc-banner-carousel__btn-next",
    attrs: {
      "href": "javascript:void(0);"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.next($event)
      }
    }
  }, [_c('span', [_vm._v("次へ")])])]), _vm._v(" "), (_vm.fixed) ? _c('button', {
    staticClass: "bc-banner-carousel__close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.fixedDestroy($event)
      }
    }
  }, [_c('i', [_vm._v("閉じる")])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ae95420","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared/bc-banner/components/Carousel.vue
// module id = 508
// module chunks = 1